import { forwardRef } from "react";
import { Form } from "@shared/components";
import { FormAutocompleteProps } from "@shared/components/Form/types";

export const VouchersAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return <Form.Autocomplete {...props} ref={ref} labelField="name" />;
});

VouchersAutocomplete.displayName = "VouchersAutocomplete";
